import * as APIModels from "../../../models";

export default function DFSSubmissionSummary({
    upload,
}: {
    upload: APIModels.eFile;
}) {
    return (
        <>
            <div className="row">
                <div className="col-6">
                    <div className="mb-2">
                        <label htmlFor="upoadFilename" className="form-label">
                            Filename
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="upoadFilename"
                            value={upload.filename}
                            readOnly
                        />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="attorneyName" className="form-label">
                            Attorney Filing on Behalf Of
                        </label>
                        <input
                            type="name"
                            className="form-control"
                            id="attorneyName"
                            value={upload.attorneyName}
                            readOnly
                        />
                    </div>
                    <div className="mb-2">
                        <label className="form-label">Additional Files</label>
                        {upload.exhibits &&
                            upload.exhibits.filenames &&
                            upload.exhibits.filenames.map((v) => (
                                <input
                                    type="text"
                                    className="form-control"
                                    value={v}
                                />
                            ))}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12" style={{ fontWeight: "bolc" }}>
                    The filing attorney has the responsibility to ensure that
                    any confidential information in the filled documents
                    compiles with all state rules,statues, and codes. By
                    clicking the Submit button below you are acknowledging that
                    you have redacted or prepared the attached document(s) in
                    accordance with all state confidentiality requirements.
                    eFileMadeEasy does not check or redact any information.
                </div>
            </div>
        </>
    );
}
